import React from 'react';
import styles from './templateFields.module.scss';

export default function Subtitle({ children }) {
  return <label className={styles.subtitle}>{children}</label>;
}
